import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Tooltip } from "@mantine/core";
import { useDatasetGroups } from "@sweco-se/reality-frontend";
import type { FC } from "react";

export const DatasetGroupIcons: FC<{ include: Array<string> }> = ({
  include,
}) => {
  const datasetGroups = useDatasetGroups();
  return (
    <Avatar.Group spacing="sm">
      {datasetGroups
        .filter((dg) => include.includes(dg.name))
        .map((dg) => (
          <Tooltip key={dg.name} label={dg.label} withArrow>
            <Avatar color="green.7" size="sm">
              <FontAwesomeIcon icon={dg.icon} />
            </Avatar>
          </Tooltip>
        ))}
    </Avatar.Group>
  );
};
